import { createSlice } from '@reduxjs/toolkit';

export const components = createSlice({
  name: 'SUPPLIER_MATCHES',
  initialState: [], // this comes from preloadedState in the store
  reducers: {
    setCustomerMatches(state, action) {
      // Indicates the specific supplier matches tailored for the customers input selections.
      const { payload } = action;
      const { customerMatches } = payload;

      return {
        ...state,
        customerMatches,
      };
    },

    setSubcategoryMaxMatches(state, action) {
      const { payload } = action;
      const { subcategoryMaxMatches } = payload;

      return {
        ...state,
        subcategoryMaxMatches,
      };
    },

    setRequiresLegalStatementAboveNav(state, action) {
      const { payload } = action;
      const { requiresLegalStatementAboveNav } = payload;

      return {
        ...state,
        requiresLegalStatementAboveNav,
      };
    },

    setMatchLevel(state, action) {
      const { payload } = action;
      const { matchLevel } = payload;

      return {
        ...state,
        matchLevel,
      };
    },

    setSupplierMatchSelectionEnabled(state, action) {
      const { payload } = action;
      const { supplierMatchSelectionEnabled } = payload;

      return { ...state, supplierMatchSelectionEnabled };
    },
  },
});

const { actions, reducer } = components;

export const {
  setCustomerMatches,
  setSubcategoryMaxMatches,
  setRequiresLegalStatementAboveNav,
  setMatchLevel,
  supplierMatchSelectionEnabled,
} = actions;

export default reducer;
